import i18n from "../../../utilities/i18n";

export const optionalColumnsList = i18n.t("payments.eraSearchTable");

export const columnsNameList1 = [
    'payer_name', //default selected 1
    'payee_name', //default selected 2
    'payment_number', //default selected 3
    'payment_date', //default selected 4
    'era_total_amount', //default selected 5
    'payment_mode', //default selected 6
    'era_received_date', //default selected 7
    'claim_id', //default selected 8
    'payer_icn', //default selected 9
    'patient_last_name', //default selected 10
    'patient_first_name', //default selected 11
    'date_of_service', //default selected 12
    'procedure_code', //default selected 13
    'procedure_modifier_code', //default selected 14
    'procedure_charge_amount', //default selected 15
    'procedure_payment_amount', //default selected 16
    'service_provider_name', //default selected 17
    'procedure_adj_type', //default selected 18
    'procedure_adj_amount', //default selected 19
    'procedure_adj_type2' //default selected 20
]

export const columnsNameList2 = [
    'procedure_adj_amount2', //default selected 21
    'procedure_adj_type3', //default selected 22
    'procedure_adj_amount3', //default selected 23
    'payer_account_number',//1
    'receiver_account_number',//2
    'account_number_qualifier',//3
    'additional_adjustment_amount',//4
    'additional_adjustment_type',//5
    'allowed_amount',//6
    'claim_adjustment_amount_1',//7
    'claim_adjustment_code_1',//8
    'claim_adjustment_amount_2',//9
    'claim_ adjustment_type',//10
    'claim_adjustment_type_2',//11
    'claim_frequency_type',//12
    'claim_received_date',//13
    'claim_status',//14
    'cob_payer_name',//15
    'cob_status',//16
    'corrected_procedure_code'//17
]

export const columnsNameList3 = [
    'corrected_procedure_modifier_code',//18
    'corrected_procedure_modifier_code_2',//19
    'corrected_procedure_modifier_code_3',//20
    'corrected_procedure_modifier_code_4',//21
    'credit_debit_flag_code',//22
    'currency_code',//23
    'entity_identifier_code',//24
    'id_number_qualifier',//25
    'identification_number',//26
    'npi_ein_provider_id',//27
    'npi_provider_id',//28 NPI
    'ein_provider_id', // 28 EIN
    'originating_company_identifier',//29
    'originating_company_supplemental_code',//30
    'patient_middle_name',//31
    'payee_address',//32
    'payee_address2',//33
    'payee_city',//34
    'payee_state',//35
    'payee_zip'//36

]

export const columnsNameList4 = [
    'payer_account_number_qualifier',//37
    'payer_address',//38
    'payer_address2',//39
    'payer_city',//40
    'payer_id',//41
    'payer_id_number_qualifier',//42
    'payer_plan_type',//43
    'payer_state',//44
    'payer_zip',//45
    'payment_format_code',//46
    'plb_amount_1',//47
    'plb_amount_2',//48
    'plb_amount_3',//49
    'plb_amount_4',//50
    'plb_amount_5',//51
    'plb_amount_6',//52
    'plb_fiscal_period',//53
    'plb_reason_1',//54
    'plb_reason_2',//55
    'plb_reason_3'//56

]

export const columnsNameList5 = [
    'plb_reason_4',//57
    'plb_reason_5',//58
    'plb_reason_6',//59
    'plb_rerference_1',//60
    'plb_rerference_2',//61
    'plb_rerference_3',//62
    'plb_rerference_4',//63
    'plb_rerference_5',//64
    'plb_rerference_6',//65
    'policy_term_date',//66
    'primary_payer_status',//67
    'primary_payer_name',//68
    'procedure_modifier_code_2',//69
    'procedure_modifier_code_3',//70
    'procedure_modifier_code_4',//71
    'procedure_units',//72
    'reference_identification',//73
    'remark_codes',//74
    'subscriber_first_name',//75
    'subscriber_last_name',//76
    'subscriber_middle_name',//77
    'total_charges_in_era',//78
    'total_claim_charge',//79
    'total_claim_payment',//80
    'total_claims_in_era',//81
    'total_patient_resp_on_claim',//82
    'transaction_type'//83
]

export const defaultSelectedColumnsList = [
    'payer_name', //default selected 1
    'payee_name', //default selected 2
    'payment_number', //default selected 3
    'payment_date', //default selected 4
    'era_total_amount', //default selected 5
    'payment_mode', //default selected 6
    'era_received_date', //default selected 7
    'claim_id', //default selected 8
    'payer_icn', //default selected 9
    'patient_last_name', //default selected 10
    'patient_first_name', //default selected 11
    'date_of_service', //default selected 12
    'procedure_code', //default selected 13
    'procedure_modifier_code', //default selected 14
    'procedure_charge_amount', //default selected 15
    'procedure_payment_amount', //default selected 16
    'service_provider_name', //default selected 17
    'procedure_adj_type', //default selected 18
    'procedure_adj_amount', //default selected 19
    'procedure_adj_type2', //default selected 20
    'procedure_adj_amount2', //default selected 21
    'procedure_adj_type3', //default selected 22
    'procedure_adj_amount3', //default selected 23
]

export const tableHeading2 = [
    i18n.t('payments.eraPage.table2.status'),
    i18n.t('payments.eraPage.table2.claimId'),
    i18n.t('payments.eraPage.table2.patientName'),
    i18n.t('payments.eraPage.table2.patientId'),
    i18n.t('payments.eraPage.table2.dos'),
    i18n.t('payments.eraPage.table2.charges'),
    i18n.t('payments.eraPage.table2.opening_balance'),
    i18n.t('payments.eraPage.table2.allowedAmount'),
    i18n.t('payments.eraPage.table2.paidAmount'),
    i18n.t('payments.eraPage.table2.adjustment_1_amount'),
    i18n.t('payments.eraPage.table2.adjustment_2_amount'),
    i18n.t('payments.eraPage.table2.closingBalance'),
    i18n.t('payments.eraPage.table2.action')
];
export const manualAddClaimTableHead1 = [
    i18n.t('payments.eraPage.table2.claimId'),
    i18n.t("payments.eraPage.table3.patientName"),
    i18n.t('payments.eraPage.table2.patientId'),
    i18n.t('payments.eraPage.table2.dos'),
    i18n.t('payments.eraPage.table2.charges'),
    i18n.t('payments.eraPage.table2.opening_balance'),
    i18n.t('payments.eraPage.table2.allowedAmount'),
    i18n.t('payments.eraPage.table2.paidAmount'),
    i18n.t('payments.eraPage.table2.closingBalance'),
];
export const manualAddClaimTableHead2 = [
    i18n.t('payments.eraPage.table2.claimId'),
    i18n.t("payments.eraPage.table3.patientName"),
    i18n.t('payments.eraPage.table2.dos'),
    i18n.t('payments.eraPage.table2.charges'),
    i18n.t('commons.balance'),
    i18n.t('dictionaries.payers.PayerTypes'),
    i18n.t('searchClaims.responsiblePayer'),
    i18n.t('searchClaims.action')
];

export const filter_Options = [{ "id": "claim_id", "name": "Claim ID" }, { "id": "patient_name", "name": "Patient Name" }, { "id": "patient_id", "name": "Patient ID" }, { "id": "cpt_payment", "name": "Paid Amount" }, { "id": "dos", "name": "DOS" }]

export const fields = [
    { label: 'Claim ID', key: 'claim_custom_id' },
    { label: 'Patient ID', key: 'patient_id' },
    { label: 'DOS', key: 'date_of_service' },
    { label: 'Procedure', key: 'cpt_code' },
    { label: 'Charges', key: 'charges' },
    { label: 'Reciepts', key: 'receipts' },
    { label: 'Openning Balance', key: 'opening_balance' },
];


export const labelStyle = {
    color: '#47494F',
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: "Lato",
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
    marginBottom:'7px'
};

export const typographyStyle = {
    overflow: "hidden",
    color: '#47494F',
    fontFeatureSettings: "'clig' off, 'liga' off",
    textOverflow: "ellipsis",
    fontFamily: "Lato",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal"
};

export const typographyStyleClosing = {
    overflow: "hidden",
    color: '#47494F',
    fontFeatureSettings: "'clig' off, 'liga' off",
    textOverflow: "ellipsis",
    fontFamily: "Lato",
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal"
};
